<template>
  <div>
    <header class="lyear-layout-header">

      <nav class="navbar navbar-default">
        <div class="topbar">

          <div class="topbar-left">
            <div class="lyear-aside-toggler">
              <span class="lyear-toggler-bar"></span>
              <span class="lyear-toggler-bar"></span>
              <span class="lyear-toggler-bar"></span>
            </div>
            <span class="navbar-page-title">用户首页 —— <router-link to="/index" target="_blank">网站首页</router-link></span>
          </div>

          <ul class="topbar-right">
            <li class="dropdown dropdown-profile flex">
              <span class="shou c-f0" v-show="authorStatus === null" @click="skiPage('/userAuth')">申请成为作者</span>
              <span class="shou c-f0" v-show="authorStatus === 0">正在审核中</span>
              <div v-show="authorStatus === 2">
                <span class="shou c-f0" @click="skiPage('/userAuth')">已拒绝，请重新审核</span>
                <span class="shou c-f0 ml-20" style="color: #000FFF;" @click="modal2 = true">[查看理由]</span>
              </div>
              <a href="javascript:void(0)" data-toggle="dropdown">
                <img class="img-avatar img-avatar-48 m-r-10" v-if="picture" :src="picture" :alt="username" />
                <img v-else src="../assets/images/noface.gif" alt="..." class="img-avatar img-avatar-48 m-r-10">
                <span>{{ username }}<span class="caret"></span></span>
              </a>
              <ul class="dropdown-menu dropdown-menu-right">
                <li @click="skiPage('/userInfo')"> <a href="javascript:;"><i class="mdi mdi-account"></i> 个人信息</a> </li>
                <li @click="skiPage('/userPwd')"> <a href="javascript:;"><i class="mdi mdi-lock-outline"></i> 修改密码</a>
                </li>
                <!-- <li> <a href="javascript:void(0)"><i class="mdi mdi-delete"></i> 清空缓存</a></li> -->
                <li class="divider"></li>
                <li @click="quitLogin"> <a href="javascript:;"><i class="mdi mdi-logout-variant"></i> 退出登录</a> </li>
              </ul>
            </li>
            <!--切换主题配色-->
            <li class="dropdown dropdown-skin">
              <!-- <span data-toggle="dropdown" class="icon-palette"><i class="mdi mdi-palette"></i></span> -->
              <ul class="dropdown-menu dropdown-menu-right" data-stopPropagation="true">
                <li class="drop-title">
                  <p>主题</p>
                </li>
                <li class="drop-skin-li clearfix">
                  <span class="inverse">
                    <input type="radio" name="site_theme" value="default" id="site_theme_1" checked>
                    <label for="site_theme_1"></label>
                  </span>
                  <span>
                    <input type="radio" name="site_theme" value="dark" id="site_theme_2">
                    <label for="site_theme_2"></label>
                  </span>
                  <span>
                    <input type="radio" name="site_theme" value="translucent" id="site_theme_3">
                    <label for="site_theme_3"></label>
                  </span>
                </li>
                <li class="drop-title">
                  <p>LOGO</p>
                </li>
                <li class="drop-skin-li clearfix">
                  <span class="inverse">
                    <input type="radio" name="logo_bg" value="default" id="logo_bg_1" checked>
                    <label for="logo_bg_1"></label>
                  </span>
                  <span>
                    <input type="radio" name="logo_bg" value="color_2" id="logo_bg_2">
                    <label for="logo_bg_2"></label>
                  </span>
                  <span>
                    <input type="radio" name="logo_bg" value="color_3" id="logo_bg_3">
                    <label for="logo_bg_3"></label>
                  </span>
                  <span>
                    <input type="radio" name="logo_bg" value="color_4" id="logo_bg_4">
                    <label for="logo_bg_4"></label>
                  </span>
                  <span>
                    <input type="radio" name="logo_bg" value="color_5" id="logo_bg_5">
                    <label for="logo_bg_5"></label>
                  </span>
                  <span>
                    <input type="radio" name="logo_bg" value="color_6" id="logo_bg_6">
                    <label for="logo_bg_6"></label>
                  </span>
                  <span>
                    <input type="radio" name="logo_bg" value="color_7" id="logo_bg_7">
                    <label for="logo_bg_7"></label>
                  </span>
                  <span>
                    <input type="radio" name="logo_bg" value="color_8" id="logo_bg_8">
                    <label for="logo_bg_8"></label>
                  </span>
                </li>
                <li class="drop-title">
                  <p>头部</p>
                </li>
                <li class="drop-skin-li clearfix">
                  <span class="inverse">
                    <input type="radio" name="header_bg" value="default" id="header_bg_1" checked>
                    <label for="header_bg_1"></label>
                  </span>
                  <span>
                    <input type="radio" name="header_bg" value="color_2" id="header_bg_2">
                    <label for="header_bg_2"></label>
                  </span>
                  <span>
                    <input type="radio" name="header_bg" value="color_3" id="header_bg_3">
                    <label for="header_bg_3"></label>
                  </span>
                  <span>
                    <input type="radio" name="header_bg" value="color_4" id="header_bg_4">
                    <label for="header_bg_4"></label>
                  </span>
                  <span>
                    <input type="radio" name="header_bg" value="color_5" id="header_bg_5">
                    <label for="header_bg_5"></label>
                  </span>
                  <span>
                    <input type="radio" name="header_bg" value="color_6" id="header_bg_6">
                    <label for="header_bg_6"></label>
                  </span>
                  <span>
                    <input type="radio" name="header_bg" value="color_7" id="header_bg_7">
                    <label for="header_bg_7"></label>
                  </span>
                  <span>
                    <input type="radio" name="header_bg" value="color_8" id="header_bg_8">
                    <label for="header_bg_8"></label>
                  </span>
                </li>
                <li class="drop-title">
                  <p>侧边栏</p>
                </li>
                <li class="drop-skin-li clearfix">
                  <span class="inverse">
                    <input type="radio" name="sidebar_bg" value="default" id="sidebar_bg_1" checked>
                    <label for="sidebar_bg_1"></label>
                  </span>
                  <span>
                    <input type="radio" name="sidebar_bg" value="color_2" id="sidebar_bg_2">
                    <label for="sidebar_bg_2"></label>
                  </span>
                  <span>
                    <input type="radio" name="sidebar_bg" value="color_3" id="sidebar_bg_3">
                    <label for="sidebar_bg_3"></label>
                  </span>
                  <span>
                    <input type="radio" name="sidebar_bg" value="color_4" id="sidebar_bg_4">
                    <label for="sidebar_bg_4"></label>
                  </span>
                  <span>
                    <input type="radio" name="sidebar_bg" value="color_5" id="sidebar_bg_5">
                    <label for="sidebar_bg_5"></label>
                  </span>
                  <span>
                    <input type="radio" name="sidebar_bg" value="color_6" id="sidebar_bg_6">
                    <label for="sidebar_bg_6"></label>
                  </span>
                  <span>
                    <input type="radio" name="sidebar_bg" value="color_7" id="sidebar_bg_7">
                    <label for="sidebar_bg_7"></label>
                  </span>
                  <span>
                    <input type="radio" name="sidebar_bg" value="color_8" id="sidebar_bg_8">
                    <label for="sidebar_bg_8"></label>
                  </span>
                </li>
              </ul>
            </li>
            <!--切换主题配色-->
          </ul>

        </div>
      </nav>

    </header>

    <!-- 登录失效弹出框 -->
    <Modal v-model="modal1" title="友情提示" cancel-text="" @on-ok="ok">
      <p>{{ Loginerror }},请重新登录</p>
    </Modal>
    <Modal v-model="modal2" title="审核不通过原因" ok-text="重新申请" @on-ok="skiPage('/userAuth')">
      <p>{{ reason }}</p>

    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      picture: '', // 用户头像
      Loginerror: '', // 用户头像
      modal1: false,
      authorStatus: '',
      modal2: false,
      reason: '',
      username: '' // 用户名
    }
  },


  created() { },

  mounted() {
    this.checkToken()
  },

  methods: {
    // 验证token的时效性
    async checkToken() {
      // 验证token的时效性
      let _this = this
      const tokenState = await this.util.checkToken(localStorage.getItem('token'))
      if (tokenState.result == 0) {
        _this.Loginerror = tokenState.error.errorMsg
        _this.modal1 = true
        return
      }
      if (tokenState.data.authorStatus == 2) {
        _this.tgreason(tokenState.data.loginName)
      }
      _this.picture = tokenState.data.picture
      _this.username = tokenState.data.username || tokenState.data.nickName
      _this.authorStatus = tokenState.data.authorStatus
      localStorage.setItem('authorStatus', _this.authorStatus)
    },

    ok() {
      this.$router.replace({ path: '/register' })
    },


    // 获取推搞理由
    async tgreason(account) {
      let _this = this
      const res = await _this.get_res('/members//noPassLog?account=' + account)
      _this.reason = res[0].note
    },

    // 跳转到新页面
    skiPage(page) {
      let _this = _this
      this.$router.push({ path: page })
    },

    quitLogin() {
      let _this = this
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      localStorage.removeItem('picture')
      localStorage.removeItem('authorStatus')
      _this.$router.replace({ path: '/register' })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/animate.css';
@import '../assets/css/bootstrap.min.css';
@import '../assets/css/icons.min.css';
@import '../assets/css/style.css';
</style>
